function distributionPoints(defaultCountry, clusterIcon, types, defaultRegion, campaign) {
    var maxZoom = 10;
    var markers = {};
    var coordsForNearest = []
    var typeState = {};

    var reloadTimeout;

    var mapBoxesContainer = $('.map-boxes');
    var storesList = $('.stores-list:visible');
    var storesListHeader = $('.stores-list header');
    var mapStyles = [
        {
            "featureType": "water",
            "elementType": "geometry.fill",
            "stylers": [{"color": "#d3d3d3"}]
        },
        {
            "featureType": "transit",
            "stylers": [{"color": "#808080"}, {"visibility": "off"}]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [{"visibility": "on"}, {"color": "#b3b3b3"}]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [{"color": "#ffffff"}]
        },
        {
            "featureType": "road.local",
            "elementType": "geometry.fill",
            "stylers": [{"visibility": "on"}, {"color": "#ffffff"}, {"weight": 1.8}]
        },
        {
            "featureType": "road.local",
            "elementType": "geometry.stroke",
            "stylers": [{"color": "#d7d7d7"}]
        },

        {
            "featureType": "poi",
            "elementType": "geometry.fill",
            "stylers": [{"visibility": "on"}, {"color": "#ebebeb"}]
        },

        {
            "featureType": "administrative",
            "elementType": "geometry",
            "stylers": [{"color": "#a7a7a7"}]
        },

        {
            "featureType": "road.arterial",
            "elementType": "geometry.fill",
            "stylers": [{"color": "#ffffff"}]
        },

        {
            "featureType": "road.arterial",
            "elementType": "geometry.fill",
            "stylers": [{"color": "#ffffff"}]
        },

        {
            "featureType": "landscape",
            "elementType": "geometry.fill",
            "stylers": [{"visibility": "on"}, {"color": "#efefef"}]
        },

        {
            "featureType": "road",
            "elementType": "labels.text.fill",
            "stylers": [{"color": "#696969"}]
        },

        {
            "featureType": "administrative",
            "elementType": "labels.text.fill",
            "stylers": [{"visibility": "on"}, {"color": "#737373"}]
        },

        {
            "featureType": "poi",
            "elementType": "labels.icon",
            "stylers": [{"visibility": "off"}]
        },

        {
            "featureType": "poi",
            "elementType": "labels",
            "stylers": [{"visibility": "off"}]
        },

        {
            "featureType": "road.arterial",
            "elementType": "geometry.stroke",
            "stylers": [{"color": "#d6d6d6"}]
        },

        {
            "featureType": "road",
            "elementType": "labels.icon",
            "stylers": [{"visibility": "off"}]
        },
        {
            "featureType": "poi",
            "elementType": "geometry.fill",
            "stylers": [{"color": "#dadada"}]
        }
    ];
    var clusterStyles = [
        {
            url: clusterIcon,
            height: 30,
            width: 30,
            anchor: [0, 0],
            textColor: '#fff',
            textSize: 14
        }
    ];

    var map = new google.maps.Map(document.getElementById('map'), {
        center: {lat: 52.1140348, lng: 19.533877},
        zoom: 6,
        styles: mapStyles
    });
    var cluster = new MarkerClusterer(map, null, {
        gridSize: 50,
        maxZoom: maxZoom,
        averageCenter: true,
        styles: clusterStyles
    });
    var distCluster = new MarkerClusterer(map, null, {
        gridSize: 50,
        maxZoom: maxZoom,
        averageCenter: true,
        styles: clusterStyles
    });
    var geocoder = new google.maps.Geocoder();
    var bounds;

    var infoWindow = new google.maps.InfoWindow();

    var searchInput = $('#map-search');

    function createMarker(data) {
        if (typeof data !== 'object' || data.longitude === null || data.latitude === null || types[data.type] === undefined) {
            return;
        }

        var type, icon, markerIcon;

        type = types[data.type].name;
        markerIcon = types[data.type].marker;
        icon = types[data.type].icon;

        var box = '<div class="map-box" data-type="' + data.type + '" data-id="' + data.id + '">' +
            '<h3 class="store-name type-' + data.type + '">' +
                '<a href="' + Routing.generate('app_distribution_point', {region: data.region, point: data.id, name: data.name}) + '">' +
                    data.name +
                '</a>' +
            '</h3>' +
            '<span class="type type-' + data.type + '">' +
                '<i class="icon-' + icon + '"></i> ' + type +
            '</span>' +
                '<p class="info">';

        $.each(['address', 'city', 'phone', 'email', 'website'], function (i, v) {
            if (data[v]) {
                box = box + data[v] + '<br />';
            }
        });

        box = box + '</p></div>';

        var position = new google.maps.LatLng(parseFloat(data.latitude), parseFloat(data.longitude));
        var marker = new google.maps.Marker({
            map: map,
            position: position,
            icon: markerIcon
        });

        marker.addListener('click', function () {
            infoWindow.setContent($(box).html());
            infoWindow.open(map, marker);
        });

        marker['data-id'] = data.id;
        marker.type = data.type;
        if (data.type === 'distribution') {
            coordsForNearest.push(position)
            distCluster.addMarker(marker, false)
        } else {
            cluster.addMarker(marker, false);
        }

        mapBoxesContainer.append(box);
        bounds.extend(marker.position);
        markers[data.type][data.id] = marker;
    }

    function reset() {
        $('.toggle-type').attr({'data-action': 'hide', 'data-content': 'Ukryj'});

        markers = {};
        typeState = {};
        coordsForNearest = [];

        $.each(types, function (k, v) {
            markers[k] = {};
            typeState[k] = true;
        });

        mapBoxesContainer.html('');

        cluster.clearMarkers();
        distCluster.clearMarkers();
        bounds = new google.maps.LatLngBounds();
    }

    function loadJson(country, options) {
        reset();

        if (options === undefined) {
            options = {};
        }

        var that = this;

        that.country = country;
        that.options = options;

        if (defaultRegion !== null && options.region === undefined) {
            options.region = defaultRegion;
        }

        if (pointsJson !== undefined && options.region === undefined || options.localsource === 1) {
            processJson(pointsJson);
        } else {
            var routeParams = {
                region: options.region
            };

            if (campaign) {
                routeParams.campaign = campaign;
            }
            $.get(
                Routing.generate('app_distribution_country', routeParams),
                processJson.bind(that)
            );
        }
    }

    function processJson(data) {
        if (data.length === 0) {
            geocoder.geocode({
                'address': country,
                componentRestrictions: {country: country}
            }, function (results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                    map.setCenter(results[0].geometry.location);
                }
            });
        } else {
            for (var i in data) {
                if (data.hasOwnProperty(i)) {
                    createMarker(data[i]);
                }
            }

            if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
                var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.02, bounds.getNorthEast().lng() + 0.02);
                var extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.02, bounds.getNorthEast().lng() - 0.02);
                bounds.extend(extendPoint1);
                bounds.extend(extendPoint2);
            }

            if (options.centerMap !== undefined) {
                repositionMap(options.centerMap, 12)
            } else {
                geocoder.geocode(
                    {
                        'address': country,
                        componentRestrictions: {country: country}
                    },
                    function (results, status) {
                        if (status == google.maps.GeocoderStatus.OK) {
                            map.fitBounds(bounds);
                        }
                    }
                );
            }
        }
    }

    function repositionMap(point, zoom) {
        if (zoom === undefined) {
            bounds = new google.maps.LatLngBounds();
            bounds.extend(point);

            if (coordsForNearest.length) {
                bounds.extend(
                    coordsForNearest.reduce(function (prev, curr) {
                        var cpos = google.maps.geometry.spherical.computeDistanceBetween(point, curr);
                        var ppos = google.maps.geometry.spherical.computeDistanceBetween(point, prev);

                        return cpos < ppos ? curr : prev;
                    })
                );
            }

            map.fitBounds(bounds)
        } else {
            map.setCenter(point)
            map.setZoom(zoom)
        }
    }

    $(document).on('click', '.toggle-type', function (e) {
        e.preventDefault();

        var type = $(this).attr('data-type');
        var action = $(this).attr('data-action');

        if (markers[type]) {
            if (action === 'hide' && typeState[type] === true) {
                typeState[type] = false;

                $(this).attr('data-action', 'show');
                $(this).attr('data-content', $(this).attr('data-content-show'));

                $.each(markers[type], function (i, marker) {
                    if (type === 'distribution') {
                        distCluster.removeMarker(marker);
                    } else {
                        cluster.removeMarker(marker);
                    }
                });

                mapBoxesContainer.find('div[data-type="' + type + '"]').hide();
            } else if (action === 'show' && typeState[type] === false) {
                typeState[type] = true;

                $(this).attr('data-action', 'hide');
                $(this).attr('data-content', $(this).attr('data-content-hide'));

                $.each(markers[type], function (i, marker) {
                    if (type === 'distribution') {
                        distCluster.addMarker(marker);
                    } else {
                        cluster.addMarker(marker);
                    }
                });
            }
        }
    });

    searchInput.change(function () {
        var searchQuery = $(this).val();
        geocoder.geocode({address: searchQuery}, function (res, status) {
            if (status === google.maps.GeocoderStatus.OK) {
                window.history.replaceState(null, null, '?location=' + searchQuery);

                var address = res[0].address_components;
                if(regions_list.length) {
                    for (var i in address) {
                        if (address.hasOwnProperty(i)) {
                            if (jQuery.inArray('administrative_area_level_1', address[i]['types']) !== -1) {
                                var region = address[i]['long_name'];
                                $('#distribution_content_data').html('');

                                if ($('.regions-list a[data-region="' + region + '"]').length > 0) {
                                    $('.active-region').html(region);
                                    var routeParams = {
                                        'region': region
                                    };

                                    if (campaign) {
                                        routeParams.campaign = campaign;
                                    }

                                    $.get(Routing.generate('app_distribution_region', routeParams), function (data) {
                                        $('#distribution_content_data').html(data);
                                    });
                                }
                            }
                        }
                    }
                }
                loadJson(defaultCountry, {'centerMap': res[0].geometry.location, 'region': 'allregions'});
            }
        });
    });

    function geoError(message) {
        if (message !== undefined) {
            console.log(message);
        }

        loadJson(defaultCountry, {'localsource': 1});
    }

    var regions_list = $('.regions-list');

    $('.active-region').click(function () {
        regions_list.slideToggle(200);
    });

    $(window).load(function () {
        $('.regions').on('click', '.init', function () {
            $(this).closest('.regions').children('.region:not(.init)').toggle();
        });

        var allRegionsOptions = $('.regions').children('.region:not(.init)');
        $('.regions').on('click', '.region:not(.init)', function () {
            allRegionsOptions.removeClass('selected');
            $(this).addClass('selected');
            $('.regions').children('.init').html($(this).html());
            allRegionsOptions.toggle();
        });

        $('#distribution_regions_select').on('click', 'a.ajax', function (event) {
            event.preventDefault();

            var region = $(this).data('region');
            var url = $(this).data('ajax');
            var historyUrl = $(this).attr('href');
            var regionSelectLabel = $(this).data('label');

            loadJson(defaultCountry, {'region': region});

            window.history.pushState({
                country: defaultCountry,
                region: region,
                data: $('#distribution_content_data').html()
            }, historyUrl, historyUrl);

            $('#distribution_content_data').html('');
            if (region !== 'allregions') {
                $.get(url, function (data) {
                    $('#distribution_content_data').html(data);
                });
            }

            $('.active-region').html(regionSelectLabel);

            $('title').text(templateTitle + ' - ' + templateStoreList + ' - ' + templateRegion + ' ' + region);

            regions_list.slideToggle(200);
        });

        window.onpopstate = function (e) {
            loadJson(e.state.country, {'region': e.state.region});
            $('#distribution_content_data').html(e.state.data);
        };

        history.replaceState({
            country: defaultCountry,
            data: $('#distribution_content_data').html()
        }, location.href);
    });

    function geoLoc() {
        if ('geolocation' in navigator) {
            function filterCountry(arr) {
                return arr.filter(function (object) {
                    return object.types.filter(function (v) {
                        return v === 'country';
                    }).length > 0;
                });
            }

            navigator.geolocation.getCurrentPosition(
              function (position) {
                  var pos = new google.maps.LatLng({
                      lat: position.coords.latitude,
                      lng: position.coords.longitude
                  });

                  var geo = new google.maps.Geocoder();

                  geo.geocode(
                    {
                        location: pos
                    },
                    function (result, status) {
                        if (status === 'OK') {
                            var loc = filterCountry(result);
                            if (!loc.length) {
                                return geoError('Could not find country data');
                            }

                            var countryInfo = filterCountry(loc[0].address_components)

                            if (!countryInfo.length) {
                                return geoError('Could not determine country code');
                            }

                            var countryCode = countryInfo[0].short_name.toUpperCase();

                            loadJson(countryCode, {'centerMap': pos, 'localsource': 1});
                        } else {
                            return geoError('Geocoding failure');
                        }
                    });
              },
              function (error) {
                  return geoError(error.message);
              }
            );
        } else {
            return geoError('Geolocation unavailable');
        }
    }

    if (searchInput.val()) {
        searchInput.trigger('change');
    } else {
        geoLoc();
    }

}
